import { api } from "./apiClient";

export function createOwnerDashboardApi() {
  const confirmSale = (saleId, { sale_price, notes } = {}) => {
    const params = new URLSearchParams();
    if (sale_price) params.append("sale_price", sale_price);
    if (notes) params.append("notes", notes);
    return api.patchQuery(`/owner/confirm-sale/${saleId}?${params}`);
  };

  const rejectSale = (saleId, reason = "") => {
    const p = reason ? `?reason=${encodeURIComponent(reason)}` : "";
    return api.patchQuery(`/owner/reject-sale/${saleId}${p}`);
  };

  return { confirmSale, rejectSale };
}
